<template>
  <div>
    <el-dialog
      :title="$t('relacoes')"
      :visible.sync="dialog.relation"
      :close-on-click-modal="false"
    >
      <el-table :data="tableRelations" stripe style="width: 100%">
        <el-table-column prop="code" :label="$t('codigo')"></el-table-column>
        <el-table-column prop="name" :label="$t('nome')"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.relation = false">OK</el-button>
      </span>
    </el-dialog>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.replace({ name: 'home' })"
        :content="$t('cadastro-grupo-servicos')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter"
          ></el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t("adicionar") }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="
          tableData.filter(
            (data) =>
              !filter ||
              data.name.toLowerCase().includes(filter.toLowerCase()) ||
              data.code.toLowerCase().includes(filter.toLowerCase())
          )
        "
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="code"
          :label="$t('codigo')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="name"
          :label="$t('nome')"
        ></el-table-column>
        <el-table-column prop="relation" :label="$t('relacoes')">
          <template slot-scope="scope">
            <el-link @click="open('service', scope.row.service)">
              <el-tag type="primary" disable-transitions>
                Serviços: {{ scope.row.service.length }}
              </el-tag>
            </el-link>
            <el-link @click="open('pricetable', scope.row.pricetable)">
              <el-tag type="success" disable-transitions>
                Tabela Preço: {{ scope.row.pricetable.length }}
              </el-tag>
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { ServicesGroupService } from "@/services/customers/services.group.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "ServicesGroup",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ServicesGroupService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({ name: "services.group.add" });
    },
    open(type, list) {
      const vm = this;
      vm.tableRelations = list;
      vm.dialog.relation = true;
    },
    editar: function (id) {
      this.$router.replace({
        name: "services.group.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      const record = vm.tableData.find((x) => x.id === id);
      if (record) {
        if (record.service.length > 0 || record.pricetable.length > 0) {
          return this.$message({
            type: "error",
            duration: 6000,
            message:
              "Esse grupo tem relacionmentos com Serviços e Tabelas de Preço. É necessário retirar esses relacionamentos antes de eliminar!",
          });
        }
      }
      this.$confirm(
        i18n.t("confirmar-eliminacao-grupo-servico", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        ServicesGroupService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("grupo-servico-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              duration: 6000,
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      tableData: [],
      tableRelations: [],
      dialog: { relation: false },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>